var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlock = function SvgBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 12 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 6.334a6 6 0 1 1 12 0 6 6 0 0 1-12 0Zm1.8 0a4.2 4.2 0 0 1 6.453-3.545L2.455 8.587A4.18 4.18 0 0 1 1.8 6.334Zm1.947 3.545A4.2 4.2 0 0 0 9.545 4.08L3.747 9.879Z",
    clipRule: "evenodd"
  })));
};
export default SvgBlock;